var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.84 11.8a3.735 3.735 0 0 0 1.241-1.193A3.613 3.613 0 0 0 16.64 9a3.835 3.835 0 0 0-.28-1.51 3.918 3.918 0 0 0-.852-1.29 4.044 4.044 0 0 0-1.295-.874A4.136 4.136 0 0 0 12.671 5H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6.196a3.937 3.937 0 0 0 1.468-.3 3.85 3.85 0 0 0 1.239-.824c.353-.35.632-.766.82-1.222.188-.456.282-.943.277-1.434v-.12c0-.693-.203-1.371-.585-1.956A3.712 3.712 0 0 0 14.84 11.8zM8.057 7.5a.5.5 0 0 1 .5-.5h3.818c.438-.013.87.104 1.237.337.368.232.653.568.819.963a2.039 2.039 0 0 1-.15 1.588 2.135 2.135 0 0 1-1.259 1.022c-.21.06-.428.09-.647.09H8.556a.5.5 0 0 1-.5-.5v-3zm4.729 9.5H8.556a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4.229c.438-.013.87.104 1.237.337.368.232.653.568.819.963a2.039 2.039 0 0 1-.15 1.588 2.135 2.135 0 0 1-1.258 1.022c-.21.06-.429.09-.648.09z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.81c4e69d3178f726ad727a3562ee263d.svg";
export { ForwardRef as ReactComponent };